import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";

import Dashboard from "./pages/Dashboard";
import ConceptosCatalogo from "./pages/Conceptos";
import BalanzaEntradasSalidas from "./pages/EntradasSalidas";
import Ventas from "./pages/Ventas";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            {/* Unprotected routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Protected routes with Layout */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/catalogo/conceptos"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ConceptosCatalogo />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/balanza/entradas-salidas"
              element={
                <ProtectedRoute>
                  <Layout>
                    <BalanzaEntradasSalidas />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/ventas"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Ventas />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
